import { makeAutoObservable } from "mobx";

class GeneralStore {
    userCreditRefreshCounter: number = 0;
    constructor() {
        makeAutoObservable(this);
    }

    refreshUserCredit() {
        this.userCreditRefreshCounter += 1;
    }
    get getUserCreditRefreshCounter() {
        return this.userCreditRefreshCounter;
    }

}

export const GENERAL_STORE = new GeneralStore();